import {
    GET_BOOK_SUMMARY_REQUEST,
    GET_BOOK_SUMMARY_SUCCESS,
    GET_BOOK_SUMMARY_ERROR,
  } from "../actions/types";
  
  export const getBookSummaryReducer = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_BOOK_SUMMARY_REQUEST:
        return {
          loading: true,
        };
      case GET_BOOK_SUMMARY_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_BOOK_SUMMARY_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  